import React, { Component, Fragment } from 'react';

class Duration extends Component {
  getAllProgramDays(baseDays) {
    return {
      Weekly: baseDays,
      Monthly: baseDays * 4,
      'Bi-Monthly (2 Months)': baseDays * 8,
      'Quarterly (3 Months)': baseDays * 12
    };
  }

  render() {
    const dayCount = this.props.dayCount;
    const weekday = this.props.weekday;

    const programs =
      this.getAllProgramDays(weekday);

    return (
      <section
        className="delivery-date"
        id="duration"
      >
        <div className="step-form-input">
          <div className="goal-heading">
            <div className="goal-number">
              04
            </div>
            <h2>Length of Program</h2>
            <span>04</span>
          </div>

          <div className="program-grid">
            {Object.keys(programs).map(
              function(value, index) {
                const count =
                  programs[value];

                const rangeId =
                  this.props.getDayRangeId(
                    count
                  );

                const discountData =
                  this.props.getDiscounts(
                    rangeId,
                    count
                  );

                const discount =
                  discountData.discount;
                const discountPer =
                  discountData.discountPer;
                const clearPrice =
                  discountData.clearPrice;

                const discountPrice =
                  (clearPrice - discount) /
                  100;
              console.debug('discountData.vou');
              console.debug(discountData);
               const dayscount = discountData.vou!=undefined && (discountData.vou.type=='buyxgety')?count+parseInt(discountData.vou.free_days):count; 
                const dPrice =
                  discountPrice > 0
                    ? Math.round(
                        discountPrice /
                          dayscount
                      )
                    : 0;
                const discountType= discountData.vou!=undefined?discountData.vou.type:'';
                return (
                  <Fragment key={index}>
                    <label
                      htmlFor={
                        'day-' + count
                      }
                      className={`program-card ${(discountType=='buyxgety')?'buyxgety':''}`}
                      data-program={count}
                    >
                      <div className="days_price_info">
                        <div className="days_info">
                          <span className="avenir-heavy font-16">
                            {value}
                          </span>

                          {(discountPer > 0 ||discountType=='buyxgety') && (
                            <div className="discount-per">
                              <div className="priceflex">
                                <span className="saving avenir-roman font-13">
                                  {discountData.vou!=undefined && (discountData.vou.type=='buyxgety')?`Total ${dayscount} Days`:'Save'}
                                </span>
                                {discountType!='buyxgety' && <span className="saving-percent avenir-heavy font-16">
                                  {' '}
                                  {
                                    discountPer
                                  }
                                  %
                                </span>}
                                {discountType=='buyxgety' && <span className="saving-percent avenir-heavy font-16">+{discountData.vou.free_days} Days free</span>}
                              </div>
                            </div>
                          )}

                          <p className="per-month">
                            <span className="price avenir-medium font-14">
                              AED{' '}
                              {
                                discountPrice
                              }{' '}
                              for {count}{' '}
                              Days
                            </span>
                          </p>
                        </div>

                        <div className="days_price">
                          <p className="per-day">
                            <span className="price avenir-heavy font-20">
                              AED {dPrice}
                            </span>
                            /day
                          </p>
                        </div>
                      </div>

                      <input
                        type="radio"
                        value={count}
                        name="days"
                        id={'day-' + count}
                        checked={
                          count == dayCount
                        }
                        onChange={function(
                          e
                        ) {
                          this.props.onChange(
                            e.target.value
                          );
                        }.bind(this)}
                      />

                      <div className="custom-radio" />
                    </label>
                  </Fragment>
                );
              }.bind(this)
            )}
          </div>
        </div>
      </section>
    );
  }
}

export default Duration;
